import { ResolveFn } from '@angular/router';
import { GameInfoService } from '../../shared/services/games/game-info';
import { inject } from '@angular/core';

export const gameResolver: ResolveFn<any> = (route, state) => {
  const gameInfo = inject(GameInfoService);
  return gameInfo.getGameInfo(route.paramMap.get('id') as string);
};
